module.exports = "<div id=schedule-add class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row> <div ui-view=\"\" class=col-sm-12></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/appointments/add/template.base.html
// module id = ./components/appointments/add/template.base.html
// module chunks = 0